export default "__VITE_ASSET__CPUU9cR7__"